module.exports = __webpack_public_path__ + "6360c0b967fe94273622ed0abbb385f3.pdf";